var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    stroke: "#000000",
    viewBox: "0 -1.5 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "volume-full"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta."), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-258 -571)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277 571.02v2.053c5.872 1.131 10 5.92 10 11.932 0 5.978-4 10.609-10 11.932v2.054c6.776-0.992 12-6.843 12-13.986s-5.224-12.994-12-13.985zm-5 1.985-7 4.667v14.666l7 4.667c1.104 0 2-0.896 2-2v-20c0-1.104-0.896-2-2-2zm11 12c0-3.523-2.612-6.41-6-6.899v2c2.282 0.463 4 2.48 4 4.899s-1.718 4.436-4 4.899v2c3.388-0.489 6-3.376 6-6.899zm-25-4v8c0 1.104 0.896 2 2 2h3v-12h-3c-1.104 0-2 0.896-2 2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.0582cc2d2abb13b0f03fec9d6aafb9e6.svg";
export { ForwardRef as ReactComponent };